<!--
*  TTTech nerve-ui-components
*  Copyright(c) 2021. TTTech Industrial Automation AG.
*
*  ALL RIGHTS RESERVED.
*
*  Usage of this software, including source code, netlists, documentation,
*  is subject to restrictions and conditions of the applicable license
*  agreement with TTTech Industrial Automation AG or its affiliates.
*
*  All trademarks used are the property of their respective owners.
*
*  TTTech Industrial Automation AG and its affiliates do not assume any liability
*  arising out of the application or use of any product described or shown
*  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
*  make changes, at any time, in order to improve reliability, function or
*  design.
*
*  Contact Information:
*  support@tttech-industrial.com
*
*  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
*
* -->

<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-text-field
          id="iiotWorkloadLogsSearchInput"
          v-model="search"
          data-cy="iiotWorkloadLogsSearchInput"
          :label="$t('nerveSimpleTable.search')"
          :disabled="disabled"
          clearable
          prepend-inner-icon="mdi-magnify"
          hide-details
        />
      </v-col>
      <v-col cols="8" class="d-flex align-end justify-end">
        <div class="d-flex justify-end">
          <v-img
            id="iiotWorkloadLogsDownloadButton"
            data-cy="iiotWorkloadLogsDownloadButton"
            :disabled="disabled"
            src="/img/download.svg"
            max-height="33px"
            min-height="33px"
            min-width="33px"
            max-width="33px"
            class="nerve-icon"
            :class="{ pointer: !disabled }"
            title="Download"
            @click="onDownload"
          />

          <v-img
            id="iiotWorkloadLogsCopyButton"
            data-cy="iiotWorkloadLogsCopyButton"
            :disabled="disabled"
            src="/img/Copy.svg"
            max-height="33px"
            min-height="33px"
            min-width="33px"
            max-width="33px"
            class="nerve-icon"
            :class="{ pointer: !disabled }"
            title="Copy"
            @click="onCopy"
          />
          <v-img
            id="iiotWorkloadLogsFreezeButton"
            data-cy="iiotWorkloadLogsFreezeButton"
            :disabled="disabled"
            :src="freezeIcon"
            max-height="33px"
            min-height="33px"
            min-width="33px"
            max-width="33px"
            class="nerve-icon"
            :class="{ pointer: !disabled }"
            :title="freezeTitle"
            @click="onFreeze"
          />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div ref="logsContainer" :class="{ 'logs-div-bcg-color': !loading }" class="logs-div">
          <ul v-if="!loading">
            <li v-for="(log, index) of filteredLogs" :key="index">{{ log }}</li>
          </ul>
          <v-progress-linear v-else class="logs-loader" indeterminate color="primary"></v-progress-linear>
          <div id="anchor"></div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'NerveWorkloadLogs',
  props: {
    logs: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      search: '',
      freeze: false,
    };
  },
  computed: {
    filteredLogs() {
      return this.logs.filter((log) => {
        if (this.search) {
          return log.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
        }
        return true;
      });
    },
    stringifiedLogs() {
      return this.filteredLogs.join('\n');
    },
    freezeIcon() {
      return this.freeze ? '/img/Play.svg' : '/img/Pause.svg';
    },
    freezeTitle() {
      return this.freeze ? 'Load' : 'Pause';
    },
  },
  watch: {
    loading(value) {
      if (!value) {
        this.scrollToBottom();
      }
    },
  },
  methods: {
    onDownload() {
      if (this.disabled) {
        return;
      }
      this.$emit('download-logs');
    },
    onCopy() {
      if (this.disabled) {
        return;
      }
      this.$emit('copy-logs', this.stringifiedLogs);
    },
    onFreeze() {
      if (this.disabled) {
        return;
      }
      this.freeze = !this.freeze;
      this.$emit('freeze-logs', this.freeze);
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.logsContainer;
        container.scrollTop = container.scrollHeight;
      });
    },
  },
};
</script>

<style scoped>
ul {
  list-style-type: none;
}

.cube-button {
  width: 30px; /* Adjust the width to your desired size */
  height: 30px !important; /* Adjust the height to your desired size */
  min-width: 0px !important;

  /* Apply additional styles to make it look like a cube */
  border: none;
  border-radius: 5;
}

.logs-div {
  height: 450px;
  width: 100%;
  overflow: auto;
}

.logs-div * {
  overflow-anchor: none;
}

#anchor {
  overflow-anchor: auto;
  height: 1px;
}

.logs-div-bcg-color {
  background-color: #e0e0e0;
}

.nerve-icon {
  margin: 0px 5px;
}

.nerve-icon[disabled] {
  filter: opacity(30%) grayscale(100%) invert(95%);
}
</style>
